"use client";
import Image from "next/image";
import React from "react";
import styles from "./client.module.scss";
import { toWebp } from "@/utils/common";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "@splidejs/react-splide/css";
// import { Technology } from "../../Services/index";
interface CardProps {
  item: any;
  className?: string;
  data?: any;
}

const Card: React.FC<CardProps> = ({ item, className = "", data }) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;
  const technologies = item?.technologies?.[0]?.technologies;

  return (
    <div className={`${className} relative`}>
      <div className="flex flex-col md:justify-between justify-start md:h-full h-auto">
        <div>
          <div className="flex md:flex-row flex-col md:gap-[32px] gap-[12px] mt-4 md:items-start items-center">
            {item?.key_points &&
              item.key_points.map((val: any, i: number) => {
                return (
                  <p
                    key={i}
                    className="flex gap-2 text-subtitle-3 font-semibold text-white"
                  >
                    <span>{val?.title} :</span>
                    {val.numbers}
                  </p>
                );
              })}
          </div>
        </div>
        <div className="relative pt-[32px]">
          <Image
            src={toWebp(`${baseUrl}${data?.image?.data?.attributes?.url}`)}
            alt={data?.attributes?.image?.data?.attributes?.alt}
            width={970 * 2}
            height={718 * 2}
            quality={100}
            className="w-full xl:h-[375px] md:h-[261px] h-[324px] block object-cover"
          />

          <div className="absolute w-full left-0 bottom-0 px-[0px] pt-[20px] md:p-[20px_25px] bg-[linear-gradient(180deg,rgba(176,217,247,0.3)_0%,#0086E680_100%)] backdrop-blur-[10px] transition-opacity duration-300 overflow-hidden">
            <div className="flex justify-between items-center md:flex-row flex-col gap-[20px]">
              <p className="text-white font-[600] text-[16px] leading-[22.2px]">
                Tech Stack
              </p>

              {technologies?.length > 3 ? (
                <div
                  className={`mb-[10px] sm:mb-[0px] w-[100%] sm:w-[40%] xl:w-[30%] ${styles.marque}`}
                >
                  <Splide
                    options={{
                      type: "loop",
                      drag: "free",
                      focus: "center",
                      arrows: false,
                      pagination: false,
                      autoWidth: true,
                      gap: "8px",
                      autoScroll: {
                        speed: 1,
                        pauseOnHover: true,
                        pauseOnFocus: false,
                      },
                    }}
                    extensions={{ AutoScroll }}
                    className="marquee-splide"
                  >
                    {technologies?.map((tech: any, idx: number) => (
                      <SplideSlide key={`stack-${idx}`}>
                        <div className="bg-white flex justify-center items-center w-[42px] h-[42px]">
                          {tech?.image?.data?.attributes?.url ? (
                            <Image
                              width={42}
                              height={42}
                              src={`${baseUrl}${toWebp(tech?.image?.data?.attributes?.url)}`}
                              alt={
                                tech?.image?.data?.attributes
                                  ?.alternativeText || tech?.name
                              }
                              className="w-[32px] h-[32px] object-cover"
                              quality={100}
                            />
                          ) : (
                            <div className="w-[32px] h-[32px] bg-[#E6EAF0]" />
                          )}
                        </div>
                      </SplideSlide>
                    ))}
                  </Splide>
                </div>
              ) : (
                <div
                  className={`mb-[10px] sm:mb-[0px] w-[100%] sm:w-[40%] xl:w-[20%] flex gap-[12px] whitespace-nowrap justify-end items-center overflow-hidden`}
                >
                  <div className="flex gap-[12px]">
                    {technologies?.map((tech: any, i: number) => {
                      const technology = tech;

                      return (
                        <div
                          key={"stack-0-" + i}
                          className="bg-white w-[42px] h-[42px] aspect-square flex items-center justify-center object-contain object-center p-[4px] flex-shrink-0"
                        >
                          <Image
                            src={
                              technology?.image?.data?.attributes?.url
                                ? `${baseUrl}${toWebp(technology.image.data.attributes.url)}`
                                : "/fallback-tech.svg"
                            }
                            alt={
                              technology?.image?.data?.attributes
                                ?.alternativeText || technology?.name
                            }
                            width={100 * 2}
                            height={100 * 2}
                            quality={100}
                            className="w-full h-full object-contain"
                            loading="lazy"
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Card;